import React from "react";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import "../Style/login.css";

const VehicleAdvanceForm = ({
  setRows,
  rows,
  handleChange,
  // handleAddRows,
  handleSave,
  filteredVehicle,
  handleVehicleChange,
  handleVehicleSelect,
  handleKeyDown,
}) => {
  return (
    <>
      <Form onSubmit={handleSave}>
        <Row>
          <Col md={12}>
            <div className="excel-table-container">
              <Table bordered hover responsive className="excel-table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Vehicle</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.slice(0, 50).map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      {/* VEHICLE */}
                      <td style={{ position: "relative" }}>
                        <Form.Control
                          id={`vehicle-${index}`}
                          type="text"
                          value={row.vehicle_number || ""}
                          onChange={(e) => handleVehicleChange(index, e)}
                          onKeyDown={(e) => handleKeyDown(index, e)}
                          onFocus={() => {
                            if (row.filteredVehicle?.length > 0) {
                              const updated = [...rows];
                              updated[index].showVehicleList = true;
                              setRows(updated);
                            }
                          }}
                          autoComplete="off"
                        />

                        {row.showVehicleList &&
                          row.filteredVehicle?.length > 0 && (
                            <div className="vehicle-dropdown">
                              {row.filteredVehicle.map((vehicle, vIndex) => (
                                // <div
                                //   key={vehicle.id}
                                //   className="vehicle-option"
                                //   onMouseDown={(e) => e.preventDefault()}
                                //   onClick={() =>
                                //     handleVehicleSelect(index, vehicle)
                                //   }
                                // >
                                //   {vehicle.vehicle_number}
                                // </div>
                                <div
                                  key={vehicle.id}
                                  className="vehicle-option"
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={() =>
                                    handleVehicleSelect(index, vehicle)
                                  }
                                  style={{
                                    background:
                                      vIndex === row.highlightedVehicleIndex
                                        ? "#007bff22"
                                        : "#fff",
                                  }}
                                >
                                  {vehicle.vehicle_number}
                                </div>
                              ))}
                            </div>
                          )}
                      </td>

                      {/* AMOUNT */}
                      <td>
                        <Form.Control
                          id={`amount-${index}`}
                          type="number"
                          value={row.amount}
                          onChange={(e) =>
                            handleChange(index, "amount", e.target.value)
                          }
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              if (index === 24) {
                                document.getElementById("saveBtn")?.click();
                              } else {
                                document
                                  .getElementById(`vehicle-${index + 1}`)
                                  ?.focus();
                              }
                            }
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
        <div className="d-flex justify-content-end mt-3">
          {/* <Button variant="success" onClick={handleAddRows}>
            Add Rows
          </Button> */}
          <Button
            id="saveBtn"
            variant="primary"
            type="submit"
            style={{ outline: "none", border: "none" }}
          >
            Save
          </Button>
        </div>
      </Form>
    </>
  );
};

export default VehicleAdvanceForm;
